// Add progressive enhancement class
document.documentElement.classList.add("js");

class ScrollCarousel extends HTMLElement {
  constructor() {
    super();

    this.pane = this.querySelector(".scroll-carousel__pane");
    this.btnNext = this.querySelector(".scroll-carousel__next");
    this.btnPrev = this.querySelector(".scroll-carousel__prev");
    this.states = {
      isAtScrollStart: "is-at-scroll-start",
      isAtScrollEnd: "is-at-scroll-end",
    };

    this.bind();
    this.updateScrollState();
  }

  bind() {
    const _this = this;

    this.pane.addEventListener(
      "scroll",
      (e) => {
        this.updateScrollState();
      },
      { passive: true }
    );

    this.btnNext.addEventListener("click", (e) => {
      this.onClickNext();
    });

    this.btnPrev.addEventListener("click", (e) => {
      this.onClickPrev();
    });
  }

  onClickNext() {
    this.pane.scroll({
      left: this.pane.scrollLeft + this.getScrollSize(),
      top: 0,
      behavior: "smooth",
    });
  }

  onClickPrev() {
    this.pane.scroll({
      left: this.pane.scrollLeft - this.getScrollSize(),
      top: 0,
      behavior: "smooth",
    });
  }

  getScrollSize() {
    let offsetWidth = this.offsetWidth;

    if (offsetWidth < 1024) {
      return offsetWidth / 1.5;
    } else {
      return offsetWidth / 3;
    }
  }

  updateScrollState() {
    if (this.pane.scrollLeft < 100) {
      this.classList.add(this.states.isAtScrollStart);
    } else {
      this.classList.remove(this.states.isAtScrollStart);
    }

    if (
      this.pane.scrollLeft >
      this.pane.scrollWidth - this.pane.clientWidth - 100
    ) {
      this.classList.add(this.states.isAtScrollEnd);
    } else {
      this.classList.remove(this.states.isAtScrollEnd);
    }
  }
}

customElements.define("scroll-carousel", ScrollCarousel);

class ScrollDrag extends HTMLElement {
  constructor() {
    super();

    this.isDragging = false;
    this.pane = this.firstElementChild;
    this.pos = {
      left: 0,
      top: 0,
      x: 0,
      y: 0,
    };

    this.bind();
  }

  bind() {
    this.addEventListener("mousedown", this.onMouseDown);
    this.addEventListener("mouseleave", this.onMouseUp);

    let paneChildren = this.pane.children;
    for (let i = 0; i < paneChildren.length; i++) {
      paneChildren[i].addEventListener("click", (e) => {
        this.onClick(e);
      });
    }
  }

  onClick(e) {
    console.log(this.isDragging);
    if (this.isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  onMouseDown(e) {
    e.preventDefault();

    this.isDragging = false;
    this.pane.classList.add("is-dragging");

    this.pos = {
      left: this.pane.scrollLeft,
      top: this.pane.scrollTop,
      x: e.clientX,
      y: e.clientY,
    };

    this.addEventListener("mousemove", this.onMouseMove);
    this.addEventListener("mouseup", this.onMouseUp);
  }

  onMouseMove(e) {
    this.isDragging = true;

    const dx = e.clientX - this.pos.x;
    const dy = e.clientY - this.pos.y;

    this.pane.scrollTop = this.pos.top - dy;
    this.pane.scrollLeft = this.pos.left - dx;
  }

  onMouseUp(e) {
    console.log(this);
    this.pane.classList.remove("is-dragging");

    this.removeEventListener("mousemove", this.onMouseMove);
    this.removeEventListener("mouseup", this.onMouseUp);

    if (this.isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}

customElements.define("scroll-drag", ScrollDrag);
